/**
 * Единственная точка монтирования панели выпадающего поиска (ставится один раз
 * в шапке, header.js). Пока панель закрыта — ничего не рендерит и группу не
 * грузит; при открытии подставляет асинхронную обёртку (search-state.js), сама
 * панель через Teleport уходит в body.
 */
import { searchState, closeSearch, SearchPanelAsync } from './search-state';

export const SearchPanelHost = {
    components: { SearchPanelAsync },
    setup() {
        return { searchState, closeSearch };
    },
    template: `
        <SearchPanelAsync v-if="searchState.open" :initial-query="searchState.initialQuery" :source="searchState.source" @close="closeSearch" />
    `,
};
